import React, { Component } from 'react';
import { connect } from "react-redux";

class MixesComponent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="sub-sequence-chooser">
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
    };
};

export default connect(mapStateToProps, null)(MixesComponent);
